import { AnalyticsBrowser } from '@segment/analytics-next'

import { SEGMENT_WRITE_KEY } from './constants'

/**
 * Set up segment write key
 */

export const analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_WRITE_KEY })
